import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.fund.list.operation');
import { OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-portal-lpsysadmin-fund-list-operation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.fund.list.operation/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminFundListOperationComponent implements OnInit {
    @Input() view: any;

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.view == "admin") await this.service.auth.allow.membership(['admin', 'super_admin'], "/landing");
        else await this.service.auth.allow(true, "/landing");
        try {
            await this.loadGpSettings();
            await this.loadDashboard();
        } catch (e) {
            console.error('GP settings/dashboard load error:', e);
        }
        await this.load();
    }

    public dashboard: any = [];
    public gpList: string[] = [];
    public selectedGps: string[] = [];
    public showGpSettings: boolean = false;

    public async toggleGpSettings() {
        this.showGpSettings = !this.showGpSettings;
        this.cdr.detectChanges();
    }

    public async loadGpSettings() {
        const gpRes = await wiz.call("gp_list");
        if (gpRes.code == 200) {
            this.gpList = gpRes.data.gp_list;
        }
        const settingsRes = await wiz.call("gp_settings_load");
        if (settingsRes.code == 200 && settingsRes.data.settings?.selected_gps) {
            this.selectedGps = settingsRes.data.settings.selected_gps;
        }
        this.cdr.detectChanges();
    }

    public isGpSelected(gp: string): boolean {
        return this.selectedGps.includes(gp);
    }

    public async toggleGp(gp: string) {
        const idx = this.selectedGps.indexOf(gp);
        if (idx >= 0) {
            this.selectedGps.splice(idx, 1);
        } else {
            this.selectedGps.push(gp);
        }
        this.cdr.detectChanges();
    }

    public async saveGpSettings() {
        await wiz.call("gp_settings_save", { selected_gps: JSON.stringify(this.selectedGps) });
        this.showGpSettings = false;
        await this.loadDashboard();
        this.cdr.detectChanges();
    }

    public async loadDashboard() {
        const { code, data } = await wiz.call("dashboard");
        if (code == 200) {
            this.dashboard = data.dashboard;
        }
        this.cdr.detectChanges();
    }

    public loading: boolean = false;
    public list: any = [];
    public search: any = {
        text: "",
        page: 1,
        dump: 200
    }

    public pagination: any = {
        end: -1,
        start: -1,
        current: 0
    }

    public sortField: string = '';
    public sortOrder: string = 'ASC';

    public gradeOrder: any = { 'S': 1, 'A': 2, 'B': 3, 'C': 4, 'D': 5, '': 6 };
    public gradeStyle: any = {
        'S': 'bg-blue-100 text-blue-700 border border-blue-300',
        'A': 'bg-emerald-100 text-emerald-700 border border-emerald-300',
        'B': 'bg-yellow-100 text-yellow-700 border border-yellow-300',
        'C': 'bg-orange-100 text-orange-700 border border-orange-300',
        'D': 'bg-red-100 text-red-700 border border-red-300',
    };

    public async toggleSort(field: string) {
        if (this.sortField === field) {
            this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
        } else {
            this.sortField = field;
            const textFields = ['name', 'gp', 'company', 'type', 'investment_resource', 'category', 'manager'];
            this.sortOrder = textFields.includes(field) ? 'ASC' : 'DESC';
        }

        const dir = this.sortOrder === 'ASC' ? 1 : -1;
        this.list.sort((a, b) => {
            let va: any, vb: any;
            if (field === 'gp') {
                va = a.gp_string || ''; vb = b.gp_string || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'registered_date') {
                va = a.registered_date || ''; vb = b.registered_date || '';
            } else if (field === 'name') {
                va = a.name || ''; vb = b.name || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'type') {
                va = a.type || ''; vb = b.type || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'lp') {
                va = a.lp_count || 0; vb = b.lp_count || 0;
                return (va - vb) * dir;
            } else if (field === 'investment_resource') {
                va = a.investment_resource || ''; vb = b.investment_resource || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'category') {
                va = a.category || ''; vb = b.category || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'total_amount') {
                va = a.total_amount || 0; vb = b.total_amount || 0;
                return (va - vb) * dir;
            } else if (field === 'company') {
                va = (a.investment && a.investment[0]?.company_name) || '';
                vb = (b.investment && b.investment[0]?.company_name) || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'founded') {
                va = (a.investment && a.investment[0]?.extra?.founded) || '';
                vb = (b.investment && b.investment[0]?.extra?.founded) || '';
            } else if (field === 'manager') {
                va = (a.investment && a.investment[0]?.manager_name) || '';
                vb = (b.investment && b.investment[0]?.manager_name) || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'investment_date') {
                va = (a.investment && a.investment[0]?.investment_date) || '';
                vb = (b.investment && b.investment[0]?.investment_date) || '';
            } else if (field === 'investment_amount') {
                va = (a.investment && a.investment[0]?.investment_amount) || 0;
                vb = (b.investment && b.investment[0]?.investment_amount) || 0;
                return (va - vb) * dir;
            } else if (field === 'investment_total') {
                const sumInv = (item) => {
                    if (!item.investment || item.investment.length === 0) return 0;
                    let total = 0;
                    for (const inv of item.investment) total += (inv.investment_amount || 0);
                    return total;
                };
                va = sumInv(a); vb = sumInv(b);
                return (va - vb) * dir;
            } else if (field === 'latest_grade') {
                va = this.gradeOrder[(a.investment && a.investment[0]?.latest_grade) || ''] || 6;
                vb = this.gradeOrder[(b.investment && b.investment[0]?.latest_grade) || ''] || 6;
                return (va - vb) * dir;
            } else {
                return 0;
            }
            return (va > vb ? 1 : va < vb ? -1 : 0) * dir;
        });
        this.cdr.detectChanges();
    }

    public sortIcon(field: string): string {
        if (this.sortField !== field) return ' ↕';
        return this.sortOrder === 'ASC' ? ' ▲' : ' ▼';
    }

    public async load(page: number = 1) {
        if (this.loading) return;
        this.loading = true;
        this.pagination.current = page;
        this.search.page = page;
        this.list = [];
        this.cdr.detectChanges();

        const { code, data } = await wiz.call("search", this.search);

        if (code == 200) {
            let { rows, lastpage } = data;
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.list = rows;
            this.pagination.start = startpage;
            this.pagination.end = lastpage;
        }

        this.loading = false;
        this.cdr.detectChanges();
    }
    public iterItems(item: any) {
        if (item.investment.length == 0) {
            let row: any = JSON.parse(JSON.stringify(item));
            row.investment = {};
            row._rowspan = 1;
            return [row];
        }

        let rows: any = [];
        let sum = 0;
        for (let i = 0; i < item.investment.length; i++) {
            let row: any = JSON.parse(JSON.stringify(item));
            if (i == 0) row._rowspan = item.investment.length;
            row.investment = item.investment[i];
            sum += row.investment.investment_amount;
            rows.push(row);
        }

        rows[0].investment_total = sum;
        return rows;
    }

    public formatter: any = {
        date: (date) => {
            if (!date) return "-";
            let res: any = moment(date).format("YYYY-MM-DD");
            if (res == 'Invalid date') return "-";
            return res;
        },
        manager: (name) => {
            if (!name) return "-";
            return name;
        }
    }

    public exporting: boolean = false;

    public async exportExcel() {
        if (this.exporting) return;
        this.exporting = true;
        this.cdr.detectChanges();

        try {
            const response = await fetch('/wiz/api/portal.lpsysadmin.fund.list.operation/export_excel', {
                method: 'POST',
                body: new FormData(),
                credentials: 'same-origin'
            });
            if (!response.ok) throw new Error('Server error');
            const blob = await response.blob();
            if (blob.size === 0) throw new Error('Empty response');
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const today = new Date().toISOString().slice(0, 10).replace(/-/g, '');
            a.download = `운용중인조합_${today}.xlsx`;
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            this.service.alert.error('엑셀 다운로드 실패');
        }

        this.exporting = false;
        this.cdr.detectChanges();
    }
}

export default PortalLpsysadminFundListOperationComponent;